import React, { useState,useEffect } from 'react'
import {MDBRow, MDBCol, MDBInput, MDBBtn, MDBBtnGroup ,MDBIcon, MDBContainer} from 'mdbreact';
/* import { MDBContainer, MDBRow, MDBCol, MDBInput, MDBBtn, MDBIcon
  ,MDBModal,MDBModalBody , MDBModalHeader, MDBModalFooter } from 'mdbreact'; */

import Axios from 'axios';

import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import WarningBox from '../components/WarningBox';


import { toast, ToastContainer} from "mdbreact";



const AddEditExpense=(props)=>{

  const useMountEffect = (functionName) => useEffect(functionName, [])

  

       
  const bearer={
    headers: {
       Authorization: "Bearer " + sessionStorage.getItem("hash")
    }
  }
  const [frm, setValues] = useState({
       code:'',
       description:'',
       usertoken: sessionStorage.getItem("msal.uc")
        
  });
  
  
      
  const [passwordShown, setPasswordShown] = useState(false);

  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };

  const updateField = e => {
       
    const target=e.target;
   
    let  value =target.value;
    let name=target.id;
  
    if(target.type==="checkbox")
    {
      value=target.checked;
      
      setValues({ ...frm, [name]: value });
    }
    else
    {
      setValues({ ...frm, [name]: value });
    }

   

};

      

   
  function submitHandler (event){
        event.preventDefault();
        event.target.className += " was-validated";
        
         saveexpense();

  }
    

  const [errorMessage,setErrorMessage]=useState("");

  const [modalWarning,showWarningBox]=useState(false);
  
  const toggleWarningBox = () => {
    showWarningBox(!modalWarning);
  
    }


   

  const loadexpensedetails=()=>
  {
    
    Axios.get(props.apiServer + '/loadexpensedetails?acode=' + props.usercode ,bearer)
      .then(res => 
      {
        if(res.data!=="empty")
        {
         
            setValues({ ...frm,
              code:props.usercode,
              description: res.data.description ,

              
            });   
                  
                  
        }
        else
        {
       
            console.log('No record');
        
        }
           
    
      })
      
      .catch(error => {
        setErrorMessage(error);
        toggleWarningBox();
          
      });  
    
         
  }


  const saveexpense=()=> {
    
     const data =frm;
   
     Axios.post(props.apiServer + "/saveexpense", data,bearer).then(res => {
      
       if (res.data.status === "1") {
      
           
            setValues({...frm, code : res.data.code});
          props.refreshGrid();
             toast.info(res.data.message, {
                closeButton: false
                
              });
       
       }
       else {
       
   
         
         setErrorMessage(res.data.message);
         toggleWarningBox();
       }
     }).catch(error => {
         setErrorMessage(error);
         toggleWarningBox();
     });
   
 }



 
 const deleteexpense=()=>
 {
    const data =frm;

   
     Axios.post(props.apiServer + "/deleteexpense", data,bearer).then(res => {
      
       if (res.data.status === "1") {
      
           
        props.refreshGrid();
          
             toast.info(res.data.message, {
                closeButton: false
                
              });
       
       }
       else {
       
   
         
         setErrorMessage(res.data.message);
         toggleWarningBox();
       }
     }).catch(error => {
         setErrorMessage(error);
         toggleWarningBox();
     });

  
   
        
 }


 const [isAdmin,checkAdmin]=useState(0);

      
 function checkAdminAccess() {
     
 
   Axios.get(props.apiServer + "/getadminaccess?username=" + sessionStorage.getItem("msal.uc"),bearer)
    .then(res => {
    
       checkAdmin(0);
       checkAdmin(res.data[0].isadmin);
   
    })
  
    .catch(error => {
     
     console.log(error);
    });  
   
  
  
  
  }

useMountEffect(loadexpensedetails);



    return (
        <React.Fragment>
        
           <MDBContainer fluid >

           
            <MDBRow>
                <MDBCol >
              
                    <form
                    className="needs-validation"
                    onSubmit={submitHandler}
                    noValidate
                    >
                     
                 
                   
                  

    
                    <MDBRow hidden>
                        <MDBCol md="10">
                        <MDBInput  
                            value={frm.code} 
                            id="code"  
                            label="code" 
                            required
                            
                            onChange={updateField}>
                                 <div className="invalid-feedback">
                                 This field is required!
                            </div>
                            <div className="valid-feedback"></div>

                        </MDBInput>
                     
                        </MDBCol>
                    </MDBRow>

         
                    <MDBRow>
                        <MDBCol md="10">
                        <MDBInput  
                            value={frm.description} 
                            id="description"  
                            label="description" 
                            required
                            onChange={updateField}>
                                 <div className="invalid-feedback">
                                 This field is required!
                            </div>
                            <div className="valid-feedback"></div>

                        </MDBInput>
                     
                        </MDBCol>
                    </MDBRow>

           
                 
                   <MDBRow>
                       <MDBCol md="6">
                       <MDBBtn className="blue lighten-1" type="submit">
                        Save
                    </MDBBtn>  {props.usercode==="" ?
                           (<MDBBtn id="cmdClose" className="blue lighten-4 blue-text"  onClick={props.toggleModal}>
                           Close
                       </MDBBtn>):(  
                       <MDBBtn color="danger" onClick={deleteexpense}>
                       Delete
                   </MDBBtn>
                      
                       
                    
                    )}
                       </MDBCol>
                       <MDBCol md="6">
                     
                       
                       </MDBCol>
                   </MDBRow>

                   
                  
                    </form>
                  
                </MDBCol>
            </MDBRow>
            </MDBContainer>
            <ToastContainer
            hideProgressBar={true}
            newestOnTop={true}
            autoClose={5000}/>

        
            <WarningBox errorMessage={errorMessage} isOpen={modalWarning} toggleModal={toggleWarningBox}/>
            {/* <MessagePersonalInfo /> */}
        </React.Fragment>
    );

}
export default AddEditExpense
